export default {
  data() {
    return {
      startTime: new Date(),
    };
  },
  watch: {
    $route() {
      this.resetTime();
    },
  },
  methods: {
    resetTime() {
      this.startTime = new Date();
    },
    elapsedTimeInSeconds() {
      const endTime = new Date();
      const timeDiff = endTime - this.startTime;
      return Math.round(timeDiff / 1000);
    },
  },
};
